import { Polyline } from "../api/polyline";
export const polyline = (pts, attribs) => new Polyline(pts, attribs);
